import React, { useState } from "react";
import { Form, Offcanvas, Spinner } from "react-bootstrap";
import { cdiscManagementService } from "../../../APIServices/CDISC/cdiscManagementService";
import { NoDataFoundTable, PageLoader } from "../../../Components/NoDataFoundTable/NoDataFoundTable";

const AddFormLibrary = ({
  Show,
  Hide,
  Title,
  getStudyDataEntry,
  getStudyFormTemplatesData,
  studyId,
  libraryTemplate,
  loader,
  formId
}) => {
  const [formData, setFormData] = useState({});
  const [buttonLoader, setButtonLoader] = useState(false);

  const isFormValid = () => {
    if (!libraryTemplate) return false;
    const requiredFields = libraryTemplate.filter(
      (item) => item.permission === "require"
    );
    return requiredFields.every(
      (field) => formData[field.name] && formData[field.name].trim() !== ""
    );
  };

  const addNewStudyDataEntry = async () => {
    setButtonLoader(true);

    let userData = {}
    userData.studyId = studyId   
    userData.formId = formId   
    userData.dataEntry = formData   
    let data = await cdiscManagementService.addNewStudyDataEntry(userData);

    if (data?.statusCode === 200) {
      getStudyDataEntry();
      getStudyFormTemplatesData()
      setFormData({});
      Hide();
    }

    setButtonLoader(false);
  };

  return (
    <Offcanvas show={Show} onHide={Hide} placement="end">
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>{Title}</Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body>
        {loader ? (
          <PageLoader />
        ) : libraryTemplate?.length === 0 ? (
          <NoDataFoundTable MSG={`Form data not found!`} />
        ) : (
          libraryTemplate?.map((item, index) => (
            <Form.Group className="mb-2" key={index}>
              <Form.Label className="mb-1 fw-bold">
                {item.label}{" "}
                {item.permission === "require" && (
                  <span className="text-danger">*</span>
                )}
              </Form.Label>
              <Form.Control
                required={item.permission === "require"}
                type={item.type}
                value={formData[item.name] || ""}
                onChange={(e) =>
                  setFormData({
                    ...formData,
                    [item.name]: e.target.value,
                  })
                }
                placeholder={`Enter ${item.label}`}
              />
            </Form.Group>
          ))
        )}
      </Offcanvas.Body>
      <div className="text-end p-2 border-top">
        <button
          disabled={buttonLoader || !isFormValid()}
          onClick={addNewStudyDataEntry}
          className="updateProfile"
        >
          {buttonLoader ? (
            <div className="hstack gap-2">
              <Spinner size="sm" /> Adding...
            </div>
          ) : (
            Title
          )}
        </button>
      </div>
    </Offcanvas>
  );
};

export default AddFormLibrary;
